/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardAuthenticatedRouteRouteImport } from './routes/dashboard/_authenticated/route'
import { Route as DashboardAuthenticatedIndexRouteImport } from './routes/dashboard/_authenticated/index'
import { Route as DashboardAuthenticatedEvaluationSelfRouteImport } from './routes/dashboard/_authenticated/evaluation-self'
import { Route as DashboardAuthenticatedReportRouteRouteImport } from './routes/dashboard/_authenticated/report/route'
import { Route as DashboardAuthenticatedEvaluationRouteRouteImport } from './routes/dashboard/_authenticated/evaluation/route'
import { Route as DashboardAuthenticatedAdminRouteRouteImport } from './routes/dashboard/_authenticated/admin/route'
import { Route as DashboardAuthenticatedReportIndexRouteImport } from './routes/dashboard/_authenticated/report/index'
import { Route as DashboardAuthenticatedAdminIndexRouteImport } from './routes/dashboard/_authenticated/admin/index'
import { Route as DashboardAuthenticatedReportCampaignIdRouteImport } from './routes/dashboard/_authenticated/report/$campaignId'
import { Route as DashboardAuthenticatedEvaluationEvaluationIdRouteImport } from './routes/dashboard/_authenticated/evaluation/$evaluationId'
import { Route as DashboardAuthenticatedAdminTopicsRouteImport } from './routes/dashboard/_authenticated/admin/topics'
import { Route as DashboardAuthenticatedAdminTeamsRouteImport } from './routes/dashboard/_authenticated/admin/teams'
import { Route as DashboardAuthenticatedAdminFormsRouteImport } from './routes/dashboard/_authenticated/admin/forms'
import { Route as DashboardAuthenticatedAdminReportsRouteRouteImport } from './routes/dashboard/_authenticated/admin/reports/route'
import { Route as DashboardAuthenticatedAdminCampaignsRouteRouteImport } from './routes/dashboard/_authenticated/admin/campaigns/route'
import { Route as DashboardAuthenticatedAdminReportsIndexRouteImport } from './routes/dashboard/_authenticated/admin/reports/index'
import { Route as DashboardAuthenticatedAdminCampaignsIndexRouteImport } from './routes/dashboard/_authenticated/admin/campaigns/index'
import { Route as DashboardAuthenticatedAdminCampaignsCreateRouteImport } from './routes/dashboard/_authenticated/admin/campaigns/create'
import { Route as DashboardAuthenticatedAdminCampaignsCampaignIdRouteImport } from './routes/dashboard/_authenticated/admin/campaigns/$campaignId'
import { Route as DashboardAuthenticatedAdminReportsCampaignIdIndexRouteImport } from './routes/dashboard/_authenticated/admin/reports/$campaignId.index'
import { Route as DashboardAuthenticatedAdminReportsCampaignIdEmployeeIdRouteImport } from './routes/dashboard/_authenticated/admin/reports/$campaignId.$employeeId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardAuthenticatedRouteRoute =
  DashboardAuthenticatedRouteRouteImport.update({
    id: '/dashboard/_authenticated',
    path: '/dashboard',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardAuthenticatedIndexRoute =
  DashboardAuthenticatedIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardAuthenticatedRouteRoute,
  } as any)
const DashboardAuthenticatedEvaluationSelfRoute =
  DashboardAuthenticatedEvaluationSelfRouteImport.update({
    id: '/evaluation-self',
    path: '/evaluation-self',
    getParentRoute: () => DashboardAuthenticatedRouteRoute,
  } as any)
const DashboardAuthenticatedReportRouteRoute =
  DashboardAuthenticatedReportRouteRouteImport.update({
    id: '/report',
    path: '/report',
    getParentRoute: () => DashboardAuthenticatedRouteRoute,
  } as any)
const DashboardAuthenticatedEvaluationRouteRoute =
  DashboardAuthenticatedEvaluationRouteRouteImport.update({
    id: '/evaluation',
    path: '/evaluation',
    getParentRoute: () => DashboardAuthenticatedRouteRoute,
  } as any)
const DashboardAuthenticatedAdminRouteRoute =
  DashboardAuthenticatedAdminRouteRouteImport.update({
    id: '/admin',
    path: '/admin',
    getParentRoute: () => DashboardAuthenticatedRouteRoute,
  } as any)
const DashboardAuthenticatedReportIndexRoute =
  DashboardAuthenticatedReportIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardAuthenticatedReportRouteRoute,
  } as any)
const DashboardAuthenticatedAdminIndexRoute =
  DashboardAuthenticatedAdminIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardAuthenticatedAdminRouteRoute,
  } as any)
const DashboardAuthenticatedReportCampaignIdRoute =
  DashboardAuthenticatedReportCampaignIdRouteImport.update({
    id: '/$campaignId',
    path: '/$campaignId',
    getParentRoute: () => DashboardAuthenticatedReportRouteRoute,
  } as any)
const DashboardAuthenticatedEvaluationEvaluationIdRoute =
  DashboardAuthenticatedEvaluationEvaluationIdRouteImport.update({
    id: '/$evaluationId',
    path: '/$evaluationId',
    getParentRoute: () => DashboardAuthenticatedEvaluationRouteRoute,
  } as any)
const DashboardAuthenticatedAdminTopicsRoute =
  DashboardAuthenticatedAdminTopicsRouteImport.update({
    id: '/topics',
    path: '/topics',
    getParentRoute: () => DashboardAuthenticatedAdminRouteRoute,
  } as any)
const DashboardAuthenticatedAdminTeamsRoute =
  DashboardAuthenticatedAdminTeamsRouteImport.update({
    id: '/teams',
    path: '/teams',
    getParentRoute: () => DashboardAuthenticatedAdminRouteRoute,
  } as any)
const DashboardAuthenticatedAdminFormsRoute =
  DashboardAuthenticatedAdminFormsRouteImport.update({
    id: '/forms',
    path: '/forms',
    getParentRoute: () => DashboardAuthenticatedAdminRouteRoute,
  } as any)
const DashboardAuthenticatedAdminReportsRouteRoute =
  DashboardAuthenticatedAdminReportsRouteRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => DashboardAuthenticatedAdminRouteRoute,
  } as any)
const DashboardAuthenticatedAdminCampaignsRouteRoute =
  DashboardAuthenticatedAdminCampaignsRouteRouteImport.update({
    id: '/campaigns',
    path: '/campaigns',
    getParentRoute: () => DashboardAuthenticatedAdminRouteRoute,
  } as any)
const DashboardAuthenticatedAdminReportsIndexRoute =
  DashboardAuthenticatedAdminReportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardAuthenticatedAdminReportsRouteRoute,
  } as any)
const DashboardAuthenticatedAdminCampaignsIndexRoute =
  DashboardAuthenticatedAdminCampaignsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardAuthenticatedAdminCampaignsRouteRoute,
  } as any)
const DashboardAuthenticatedAdminCampaignsCreateRoute =
  DashboardAuthenticatedAdminCampaignsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => DashboardAuthenticatedAdminCampaignsRouteRoute,
  } as any)
const DashboardAuthenticatedAdminCampaignsCampaignIdRoute =
  DashboardAuthenticatedAdminCampaignsCampaignIdRouteImport.update({
    id: '/$campaignId',
    path: '/$campaignId',
    getParentRoute: () => DashboardAuthenticatedAdminCampaignsRouteRoute,
  } as any)
const DashboardAuthenticatedAdminReportsCampaignIdIndexRoute =
  DashboardAuthenticatedAdminReportsCampaignIdIndexRouteImport.update({
    id: '/$campaignId/',
    path: '/$campaignId/',
    getParentRoute: () => DashboardAuthenticatedAdminReportsRouteRoute,
  } as any)
const DashboardAuthenticatedAdminReportsCampaignIdEmployeeIdRoute =
  DashboardAuthenticatedAdminReportsCampaignIdEmployeeIdRouteImport.update({
    id: '/$campaignId/$employeeId',
    path: '/$campaignId/$employeeId',
    getParentRoute: () => DashboardAuthenticatedAdminReportsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof DashboardAuthenticatedRouteRouteWithChildren
  '/dashboard/admin': typeof DashboardAuthenticatedAdminRouteRouteWithChildren
  '/dashboard/evaluation': typeof DashboardAuthenticatedEvaluationRouteRouteWithChildren
  '/dashboard/report': typeof DashboardAuthenticatedReportRouteRouteWithChildren
  '/dashboard/evaluation-self': typeof DashboardAuthenticatedEvaluationSelfRoute
  '/dashboard/': typeof DashboardAuthenticatedIndexRoute
  '/dashboard/admin/campaigns': typeof DashboardAuthenticatedAdminCampaignsRouteRouteWithChildren
  '/dashboard/admin/reports': typeof DashboardAuthenticatedAdminReportsRouteRouteWithChildren
  '/dashboard/admin/forms': typeof DashboardAuthenticatedAdminFormsRoute
  '/dashboard/admin/teams': typeof DashboardAuthenticatedAdminTeamsRoute
  '/dashboard/admin/topics': typeof DashboardAuthenticatedAdminTopicsRoute
  '/dashboard/evaluation/$evaluationId': typeof DashboardAuthenticatedEvaluationEvaluationIdRoute
  '/dashboard/report/$campaignId': typeof DashboardAuthenticatedReportCampaignIdRoute
  '/dashboard/admin/': typeof DashboardAuthenticatedAdminIndexRoute
  '/dashboard/report/': typeof DashboardAuthenticatedReportIndexRoute
  '/dashboard/admin/campaigns/$campaignId': typeof DashboardAuthenticatedAdminCampaignsCampaignIdRoute
  '/dashboard/admin/campaigns/create': typeof DashboardAuthenticatedAdminCampaignsCreateRoute
  '/dashboard/admin/campaigns/': typeof DashboardAuthenticatedAdminCampaignsIndexRoute
  '/dashboard/admin/reports/': typeof DashboardAuthenticatedAdminReportsIndexRoute
  '/dashboard/admin/reports/$campaignId/$employeeId': typeof DashboardAuthenticatedAdminReportsCampaignIdEmployeeIdRoute
  '/dashboard/admin/reports/$campaignId/': typeof DashboardAuthenticatedAdminReportsCampaignIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard/evaluation': typeof DashboardAuthenticatedEvaluationRouteRouteWithChildren
  '/dashboard/evaluation-self': typeof DashboardAuthenticatedEvaluationSelfRoute
  '/dashboard': typeof DashboardAuthenticatedIndexRoute
  '/dashboard/admin/forms': typeof DashboardAuthenticatedAdminFormsRoute
  '/dashboard/admin/teams': typeof DashboardAuthenticatedAdminTeamsRoute
  '/dashboard/admin/topics': typeof DashboardAuthenticatedAdminTopicsRoute
  '/dashboard/evaluation/$evaluationId': typeof DashboardAuthenticatedEvaluationEvaluationIdRoute
  '/dashboard/report/$campaignId': typeof DashboardAuthenticatedReportCampaignIdRoute
  '/dashboard/admin': typeof DashboardAuthenticatedAdminIndexRoute
  '/dashboard/report': typeof DashboardAuthenticatedReportIndexRoute
  '/dashboard/admin/campaigns/$campaignId': typeof DashboardAuthenticatedAdminCampaignsCampaignIdRoute
  '/dashboard/admin/campaigns/create': typeof DashboardAuthenticatedAdminCampaignsCreateRoute
  '/dashboard/admin/campaigns': typeof DashboardAuthenticatedAdminCampaignsIndexRoute
  '/dashboard/admin/reports': typeof DashboardAuthenticatedAdminReportsIndexRoute
  '/dashboard/admin/reports/$campaignId/$employeeId': typeof DashboardAuthenticatedAdminReportsCampaignIdEmployeeIdRoute
  '/dashboard/admin/reports/$campaignId': typeof DashboardAuthenticatedAdminReportsCampaignIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard/_authenticated': typeof DashboardAuthenticatedRouteRouteWithChildren
  '/dashboard/_authenticated/admin': typeof DashboardAuthenticatedAdminRouteRouteWithChildren
  '/dashboard/_authenticated/evaluation': typeof DashboardAuthenticatedEvaluationRouteRouteWithChildren
  '/dashboard/_authenticated/report': typeof DashboardAuthenticatedReportRouteRouteWithChildren
  '/dashboard/_authenticated/evaluation-self': typeof DashboardAuthenticatedEvaluationSelfRoute
  '/dashboard/_authenticated/': typeof DashboardAuthenticatedIndexRoute
  '/dashboard/_authenticated/admin/campaigns': typeof DashboardAuthenticatedAdminCampaignsRouteRouteWithChildren
  '/dashboard/_authenticated/admin/reports': typeof DashboardAuthenticatedAdminReportsRouteRouteWithChildren
  '/dashboard/_authenticated/admin/forms': typeof DashboardAuthenticatedAdminFormsRoute
  '/dashboard/_authenticated/admin/teams': typeof DashboardAuthenticatedAdminTeamsRoute
  '/dashboard/_authenticated/admin/topics': typeof DashboardAuthenticatedAdminTopicsRoute
  '/dashboard/_authenticated/evaluation/$evaluationId': typeof DashboardAuthenticatedEvaluationEvaluationIdRoute
  '/dashboard/_authenticated/report/$campaignId': typeof DashboardAuthenticatedReportCampaignIdRoute
  '/dashboard/_authenticated/admin/': typeof DashboardAuthenticatedAdminIndexRoute
  '/dashboard/_authenticated/report/': typeof DashboardAuthenticatedReportIndexRoute
  '/dashboard/_authenticated/admin/campaigns/$campaignId': typeof DashboardAuthenticatedAdminCampaignsCampaignIdRoute
  '/dashboard/_authenticated/admin/campaigns/create': typeof DashboardAuthenticatedAdminCampaignsCreateRoute
  '/dashboard/_authenticated/admin/campaigns/': typeof DashboardAuthenticatedAdminCampaignsIndexRoute
  '/dashboard/_authenticated/admin/reports/': typeof DashboardAuthenticatedAdminReportsIndexRoute
  '/dashboard/_authenticated/admin/reports/$campaignId/$employeeId': typeof DashboardAuthenticatedAdminReportsCampaignIdEmployeeIdRoute
  '/dashboard/_authenticated/admin/reports/$campaignId/': typeof DashboardAuthenticatedAdminReportsCampaignIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/dashboard'
    | '/dashboard/admin'
    | '/dashboard/evaluation'
    | '/dashboard/report'
    | '/dashboard/evaluation-self'
    | '/dashboard/'
    | '/dashboard/admin/campaigns'
    | '/dashboard/admin/reports'
    | '/dashboard/admin/forms'
    | '/dashboard/admin/teams'
    | '/dashboard/admin/topics'
    | '/dashboard/evaluation/$evaluationId'
    | '/dashboard/report/$campaignId'
    | '/dashboard/admin/'
    | '/dashboard/report/'
    | '/dashboard/admin/campaigns/$campaignId'
    | '/dashboard/admin/campaigns/create'
    | '/dashboard/admin/campaigns/'
    | '/dashboard/admin/reports/'
    | '/dashboard/admin/reports/$campaignId/$employeeId'
    | '/dashboard/admin/reports/$campaignId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/dashboard/evaluation'
    | '/dashboard/evaluation-self'
    | '/dashboard'
    | '/dashboard/admin/forms'
    | '/dashboard/admin/teams'
    | '/dashboard/admin/topics'
    | '/dashboard/evaluation/$evaluationId'
    | '/dashboard/report/$campaignId'
    | '/dashboard/admin'
    | '/dashboard/report'
    | '/dashboard/admin/campaigns/$campaignId'
    | '/dashboard/admin/campaigns/create'
    | '/dashboard/admin/campaigns'
    | '/dashboard/admin/reports'
    | '/dashboard/admin/reports/$campaignId/$employeeId'
    | '/dashboard/admin/reports/$campaignId'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/dashboard/_authenticated'
    | '/dashboard/_authenticated/admin'
    | '/dashboard/_authenticated/evaluation'
    | '/dashboard/_authenticated/report'
    | '/dashboard/_authenticated/evaluation-self'
    | '/dashboard/_authenticated/'
    | '/dashboard/_authenticated/admin/campaigns'
    | '/dashboard/_authenticated/admin/reports'
    | '/dashboard/_authenticated/admin/forms'
    | '/dashboard/_authenticated/admin/teams'
    | '/dashboard/_authenticated/admin/topics'
    | '/dashboard/_authenticated/evaluation/$evaluationId'
    | '/dashboard/_authenticated/report/$campaignId'
    | '/dashboard/_authenticated/admin/'
    | '/dashboard/_authenticated/report/'
    | '/dashboard/_authenticated/admin/campaigns/$campaignId'
    | '/dashboard/_authenticated/admin/campaigns/create'
    | '/dashboard/_authenticated/admin/campaigns/'
    | '/dashboard/_authenticated/admin/reports/'
    | '/dashboard/_authenticated/admin/reports/$campaignId/$employeeId'
    | '/dashboard/_authenticated/admin/reports/$campaignId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  DashboardAuthenticatedRouteRoute: typeof DashboardAuthenticatedRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/_authenticated': {
      id: '/dashboard/_authenticated'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardAuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/_authenticated/': {
      id: '/dashboard/_authenticated/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardAuthenticatedIndexRouteImport
      parentRoute: typeof DashboardAuthenticatedRouteRoute
    }
    '/dashboard/_authenticated/evaluation-self': {
      id: '/dashboard/_authenticated/evaluation-self'
      path: '/evaluation-self'
      fullPath: '/dashboard/evaluation-self'
      preLoaderRoute: typeof DashboardAuthenticatedEvaluationSelfRouteImport
      parentRoute: typeof DashboardAuthenticatedRouteRoute
    }
    '/dashboard/_authenticated/report': {
      id: '/dashboard/_authenticated/report'
      path: '/report'
      fullPath: '/dashboard/report'
      preLoaderRoute: typeof DashboardAuthenticatedReportRouteRouteImport
      parentRoute: typeof DashboardAuthenticatedRouteRoute
    }
    '/dashboard/_authenticated/evaluation': {
      id: '/dashboard/_authenticated/evaluation'
      path: '/evaluation'
      fullPath: '/dashboard/evaluation'
      preLoaderRoute: typeof DashboardAuthenticatedEvaluationRouteRouteImport
      parentRoute: typeof DashboardAuthenticatedRouteRoute
    }
    '/dashboard/_authenticated/admin': {
      id: '/dashboard/_authenticated/admin'
      path: '/admin'
      fullPath: '/dashboard/admin'
      preLoaderRoute: typeof DashboardAuthenticatedAdminRouteRouteImport
      parentRoute: typeof DashboardAuthenticatedRouteRoute
    }
    '/dashboard/_authenticated/report/': {
      id: '/dashboard/_authenticated/report/'
      path: '/'
      fullPath: '/dashboard/report/'
      preLoaderRoute: typeof DashboardAuthenticatedReportIndexRouteImport
      parentRoute: typeof DashboardAuthenticatedReportRouteRoute
    }
    '/dashboard/_authenticated/admin/': {
      id: '/dashboard/_authenticated/admin/'
      path: '/'
      fullPath: '/dashboard/admin/'
      preLoaderRoute: typeof DashboardAuthenticatedAdminIndexRouteImport
      parentRoute: typeof DashboardAuthenticatedAdminRouteRoute
    }
    '/dashboard/_authenticated/report/$campaignId': {
      id: '/dashboard/_authenticated/report/$campaignId'
      path: '/$campaignId'
      fullPath: '/dashboard/report/$campaignId'
      preLoaderRoute: typeof DashboardAuthenticatedReportCampaignIdRouteImport
      parentRoute: typeof DashboardAuthenticatedReportRouteRoute
    }
    '/dashboard/_authenticated/evaluation/$evaluationId': {
      id: '/dashboard/_authenticated/evaluation/$evaluationId'
      path: '/$evaluationId'
      fullPath: '/dashboard/evaluation/$evaluationId'
      preLoaderRoute: typeof DashboardAuthenticatedEvaluationEvaluationIdRouteImport
      parentRoute: typeof DashboardAuthenticatedEvaluationRouteRoute
    }
    '/dashboard/_authenticated/admin/topics': {
      id: '/dashboard/_authenticated/admin/topics'
      path: '/topics'
      fullPath: '/dashboard/admin/topics'
      preLoaderRoute: typeof DashboardAuthenticatedAdminTopicsRouteImport
      parentRoute: typeof DashboardAuthenticatedAdminRouteRoute
    }
    '/dashboard/_authenticated/admin/teams': {
      id: '/dashboard/_authenticated/admin/teams'
      path: '/teams'
      fullPath: '/dashboard/admin/teams'
      preLoaderRoute: typeof DashboardAuthenticatedAdminTeamsRouteImport
      parentRoute: typeof DashboardAuthenticatedAdminRouteRoute
    }
    '/dashboard/_authenticated/admin/forms': {
      id: '/dashboard/_authenticated/admin/forms'
      path: '/forms'
      fullPath: '/dashboard/admin/forms'
      preLoaderRoute: typeof DashboardAuthenticatedAdminFormsRouteImport
      parentRoute: typeof DashboardAuthenticatedAdminRouteRoute
    }
    '/dashboard/_authenticated/admin/reports': {
      id: '/dashboard/_authenticated/admin/reports'
      path: '/reports'
      fullPath: '/dashboard/admin/reports'
      preLoaderRoute: typeof DashboardAuthenticatedAdminReportsRouteRouteImport
      parentRoute: typeof DashboardAuthenticatedAdminRouteRoute
    }
    '/dashboard/_authenticated/admin/campaigns': {
      id: '/dashboard/_authenticated/admin/campaigns'
      path: '/campaigns'
      fullPath: '/dashboard/admin/campaigns'
      preLoaderRoute: typeof DashboardAuthenticatedAdminCampaignsRouteRouteImport
      parentRoute: typeof DashboardAuthenticatedAdminRouteRoute
    }
    '/dashboard/_authenticated/admin/reports/': {
      id: '/dashboard/_authenticated/admin/reports/'
      path: '/'
      fullPath: '/dashboard/admin/reports/'
      preLoaderRoute: typeof DashboardAuthenticatedAdminReportsIndexRouteImport
      parentRoute: typeof DashboardAuthenticatedAdminReportsRouteRoute
    }
    '/dashboard/_authenticated/admin/campaigns/': {
      id: '/dashboard/_authenticated/admin/campaigns/'
      path: '/'
      fullPath: '/dashboard/admin/campaigns/'
      preLoaderRoute: typeof DashboardAuthenticatedAdminCampaignsIndexRouteImport
      parentRoute: typeof DashboardAuthenticatedAdminCampaignsRouteRoute
    }
    '/dashboard/_authenticated/admin/campaigns/create': {
      id: '/dashboard/_authenticated/admin/campaigns/create'
      path: '/create'
      fullPath: '/dashboard/admin/campaigns/create'
      preLoaderRoute: typeof DashboardAuthenticatedAdminCampaignsCreateRouteImport
      parentRoute: typeof DashboardAuthenticatedAdminCampaignsRouteRoute
    }
    '/dashboard/_authenticated/admin/campaigns/$campaignId': {
      id: '/dashboard/_authenticated/admin/campaigns/$campaignId'
      path: '/$campaignId'
      fullPath: '/dashboard/admin/campaigns/$campaignId'
      preLoaderRoute: typeof DashboardAuthenticatedAdminCampaignsCampaignIdRouteImport
      parentRoute: typeof DashboardAuthenticatedAdminCampaignsRouteRoute
    }
    '/dashboard/_authenticated/admin/reports/$campaignId/': {
      id: '/dashboard/_authenticated/admin/reports/$campaignId/'
      path: '/$campaignId'
      fullPath: '/dashboard/admin/reports/$campaignId/'
      preLoaderRoute: typeof DashboardAuthenticatedAdminReportsCampaignIdIndexRouteImport
      parentRoute: typeof DashboardAuthenticatedAdminReportsRouteRoute
    }
    '/dashboard/_authenticated/admin/reports/$campaignId/$employeeId': {
      id: '/dashboard/_authenticated/admin/reports/$campaignId/$employeeId'
      path: '/$campaignId/$employeeId'
      fullPath: '/dashboard/admin/reports/$campaignId/$employeeId'
      preLoaderRoute: typeof DashboardAuthenticatedAdminReportsCampaignIdEmployeeIdRouteImport
      parentRoute: typeof DashboardAuthenticatedAdminReportsRouteRoute
    }
  }
}

interface DashboardAuthenticatedAdminCampaignsRouteRouteChildren {
  DashboardAuthenticatedAdminCampaignsCampaignIdRoute: typeof DashboardAuthenticatedAdminCampaignsCampaignIdRoute
  DashboardAuthenticatedAdminCampaignsCreateRoute: typeof DashboardAuthenticatedAdminCampaignsCreateRoute
  DashboardAuthenticatedAdminCampaignsIndexRoute: typeof DashboardAuthenticatedAdminCampaignsIndexRoute
}

const DashboardAuthenticatedAdminCampaignsRouteRouteChildren: DashboardAuthenticatedAdminCampaignsRouteRouteChildren =
  {
    DashboardAuthenticatedAdminCampaignsCampaignIdRoute:
      DashboardAuthenticatedAdminCampaignsCampaignIdRoute,
    DashboardAuthenticatedAdminCampaignsCreateRoute:
      DashboardAuthenticatedAdminCampaignsCreateRoute,
    DashboardAuthenticatedAdminCampaignsIndexRoute:
      DashboardAuthenticatedAdminCampaignsIndexRoute,
  }

const DashboardAuthenticatedAdminCampaignsRouteRouteWithChildren =
  DashboardAuthenticatedAdminCampaignsRouteRoute._addFileChildren(
    DashboardAuthenticatedAdminCampaignsRouteRouteChildren,
  )

interface DashboardAuthenticatedAdminReportsRouteRouteChildren {
  DashboardAuthenticatedAdminReportsIndexRoute: typeof DashboardAuthenticatedAdminReportsIndexRoute
  DashboardAuthenticatedAdminReportsCampaignIdEmployeeIdRoute: typeof DashboardAuthenticatedAdminReportsCampaignIdEmployeeIdRoute
  DashboardAuthenticatedAdminReportsCampaignIdIndexRoute: typeof DashboardAuthenticatedAdminReportsCampaignIdIndexRoute
}

const DashboardAuthenticatedAdminReportsRouteRouteChildren: DashboardAuthenticatedAdminReportsRouteRouteChildren =
  {
    DashboardAuthenticatedAdminReportsIndexRoute:
      DashboardAuthenticatedAdminReportsIndexRoute,
    DashboardAuthenticatedAdminReportsCampaignIdEmployeeIdRoute:
      DashboardAuthenticatedAdminReportsCampaignIdEmployeeIdRoute,
    DashboardAuthenticatedAdminReportsCampaignIdIndexRoute:
      DashboardAuthenticatedAdminReportsCampaignIdIndexRoute,
  }

const DashboardAuthenticatedAdminReportsRouteRouteWithChildren =
  DashboardAuthenticatedAdminReportsRouteRoute._addFileChildren(
    DashboardAuthenticatedAdminReportsRouteRouteChildren,
  )

interface DashboardAuthenticatedAdminRouteRouteChildren {
  DashboardAuthenticatedAdminCampaignsRouteRoute: typeof DashboardAuthenticatedAdminCampaignsRouteRouteWithChildren
  DashboardAuthenticatedAdminReportsRouteRoute: typeof DashboardAuthenticatedAdminReportsRouteRouteWithChildren
  DashboardAuthenticatedAdminFormsRoute: typeof DashboardAuthenticatedAdminFormsRoute
  DashboardAuthenticatedAdminTeamsRoute: typeof DashboardAuthenticatedAdminTeamsRoute
  DashboardAuthenticatedAdminTopicsRoute: typeof DashboardAuthenticatedAdminTopicsRoute
  DashboardAuthenticatedAdminIndexRoute: typeof DashboardAuthenticatedAdminIndexRoute
}

const DashboardAuthenticatedAdminRouteRouteChildren: DashboardAuthenticatedAdminRouteRouteChildren =
  {
    DashboardAuthenticatedAdminCampaignsRouteRoute:
      DashboardAuthenticatedAdminCampaignsRouteRouteWithChildren,
    DashboardAuthenticatedAdminReportsRouteRoute:
      DashboardAuthenticatedAdminReportsRouteRouteWithChildren,
    DashboardAuthenticatedAdminFormsRoute:
      DashboardAuthenticatedAdminFormsRoute,
    DashboardAuthenticatedAdminTeamsRoute:
      DashboardAuthenticatedAdminTeamsRoute,
    DashboardAuthenticatedAdminTopicsRoute:
      DashboardAuthenticatedAdminTopicsRoute,
    DashboardAuthenticatedAdminIndexRoute:
      DashboardAuthenticatedAdminIndexRoute,
  }

const DashboardAuthenticatedAdminRouteRouteWithChildren =
  DashboardAuthenticatedAdminRouteRoute._addFileChildren(
    DashboardAuthenticatedAdminRouteRouteChildren,
  )

interface DashboardAuthenticatedEvaluationRouteRouteChildren {
  DashboardAuthenticatedEvaluationEvaluationIdRoute: typeof DashboardAuthenticatedEvaluationEvaluationIdRoute
}

const DashboardAuthenticatedEvaluationRouteRouteChildren: DashboardAuthenticatedEvaluationRouteRouteChildren =
  {
    DashboardAuthenticatedEvaluationEvaluationIdRoute:
      DashboardAuthenticatedEvaluationEvaluationIdRoute,
  }

const DashboardAuthenticatedEvaluationRouteRouteWithChildren =
  DashboardAuthenticatedEvaluationRouteRoute._addFileChildren(
    DashboardAuthenticatedEvaluationRouteRouteChildren,
  )

interface DashboardAuthenticatedReportRouteRouteChildren {
  DashboardAuthenticatedReportCampaignIdRoute: typeof DashboardAuthenticatedReportCampaignIdRoute
  DashboardAuthenticatedReportIndexRoute: typeof DashboardAuthenticatedReportIndexRoute
}

const DashboardAuthenticatedReportRouteRouteChildren: DashboardAuthenticatedReportRouteRouteChildren =
  {
    DashboardAuthenticatedReportCampaignIdRoute:
      DashboardAuthenticatedReportCampaignIdRoute,
    DashboardAuthenticatedReportIndexRoute:
      DashboardAuthenticatedReportIndexRoute,
  }

const DashboardAuthenticatedReportRouteRouteWithChildren =
  DashboardAuthenticatedReportRouteRoute._addFileChildren(
    DashboardAuthenticatedReportRouteRouteChildren,
  )

interface DashboardAuthenticatedRouteRouteChildren {
  DashboardAuthenticatedAdminRouteRoute: typeof DashboardAuthenticatedAdminRouteRouteWithChildren
  DashboardAuthenticatedEvaluationRouteRoute: typeof DashboardAuthenticatedEvaluationRouteRouteWithChildren
  DashboardAuthenticatedReportRouteRoute: typeof DashboardAuthenticatedReportRouteRouteWithChildren
  DashboardAuthenticatedEvaluationSelfRoute: typeof DashboardAuthenticatedEvaluationSelfRoute
  DashboardAuthenticatedIndexRoute: typeof DashboardAuthenticatedIndexRoute
}

const DashboardAuthenticatedRouteRouteChildren: DashboardAuthenticatedRouteRouteChildren =
  {
    DashboardAuthenticatedAdminRouteRoute:
      DashboardAuthenticatedAdminRouteRouteWithChildren,
    DashboardAuthenticatedEvaluationRouteRoute:
      DashboardAuthenticatedEvaluationRouteRouteWithChildren,
    DashboardAuthenticatedReportRouteRoute:
      DashboardAuthenticatedReportRouteRouteWithChildren,
    DashboardAuthenticatedEvaluationSelfRoute:
      DashboardAuthenticatedEvaluationSelfRoute,
    DashboardAuthenticatedIndexRoute: DashboardAuthenticatedIndexRoute,
  }

const DashboardAuthenticatedRouteRouteWithChildren =
  DashboardAuthenticatedRouteRoute._addFileChildren(
    DashboardAuthenticatedRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  DashboardAuthenticatedRouteRoute:
    DashboardAuthenticatedRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
